import React from 'react';

export default function BacBlock4Lines() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-paper border-b border-line">
      <div className="max-w-[1000px] mx-auto">
        <div className="mb-24 max-w-3xl">
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink mb-6 tracking-tight">
            Tres líneas de operación, una sola capacidad operativa.
          </h2>
          <p className="text-[18px] md:text-[20px] text-ink-soft leading-[1.6]">
            La operación se despliega sobre trayectorias preventivas, hitos crónicos y rescates de continuidad, alimentando un mismo núcleo.
          </p>
        </div>
        <div className="max-w-[1024px] mx-auto w-full">
          <div className="flex flex-col md:flex-row items-stretch gap-12 lg:gap-16 mb-20">
            <div className="flex-1 flex flex-col text-left">
              <div className="text-[14px] font-semibold text-brand mb-3">Motor preventivo</div>
              <div className="text-[20px] font-bold text-ink mb-4">Episodios finitos y cascadas</div>
              <div className="text-[15px] text-ink-soft leading-relaxed mb-6">
                Encontrar antes a quien necesita pesquisa y asegurar la cascada posterior. Un EMPA alterado no cierra el episodio si existe una confirmación diagnóstica pendiente.
              </div>
              <div className="text-[13px] font-semibold text-ink-soft/50 mt-auto pt-4 border-t border-line">
                EJ: EMPA, PAP, MAMOGRAFÍA
              </div>
            </div>
            <div className="flex-1 flex flex-col text-left">
              <div className="text-[14px] font-semibold text-brand mb-3">Motor de continuidad</div>
              <div className="text-[20px] font-bold text-ink mb-4">Hitos sucesivos</div>
              <div className="text-[15px] text-ink-soft leading-relaxed mb-6">
                Dentro de personas con enfermedad conocida, identificar qué necesidad requiere acción ahora y asegurar el cumplimiento del siguiente hito en el tiempo.
              </div>
              <div className="text-[13px] font-semibold text-ink-soft/50 mt-auto pt-4 border-t border-line">
                EJ: CONTROL PSCV, HBA1C
              </div>
            </div>
            <div className="flex-1 flex flex-col text-left">
              <div className="text-[14px] font-semibold text-brand mb-3">Recuperación de continuidad</div>
              <div className="text-[20px] font-bold text-ink mb-4">Trayectorias interrumpidas</div>
              <div className="text-[15px] text-ink-soft leading-relaxed mb-6">
                Identificar eventos fallidos que comprometen la adherencia y gestionar activamente el rescate para reintegrar a la persona al flujo de atención.
              </div>
              <div className="text-[13px] font-semibold text-ink-soft/50 mt-auto pt-4 border-t border-line">
                EJ: INASISTENCIA, ABANDONO
              </div>
            </div>
          </div>
          <div className="bg-[#ccccff] p-8 text-center rounded-lg shadow-sm border border-brand/20">
            <div className="text-[16px] font-bold text-ink tracking-widest uppercase">
              NÚCLEO OPERACIONAL — CAPACIDAD OPERACIONAL COMPARTIDA
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
